import { Outlet } from "react-router-dom";
import MobileNavigationMenu from "./mobile/MobileNavigationMenu";
import DesktopNavigationMenu from "./desktop/DesktopNavigationMenu";
import ProfileDropdownMenu from "./profile/ProfileDropdownMenu";
import useLoading from "../../shared/components/loading/useLoading";
import LoadingSpinner from "../../shared/components/loading/LoadingSpinner";
import {
  PERMISSIONS_CONTROLCENTRE,
  PERMISSIONS_DATAAPI,
  ROLES,
  USERS,
} from "../../shared/lib/routesResolver";

const sections = [
  {
    code: "users",
    route: USERS,
    label: "Usuarios",
  },
  {
    code: "roles",
    route: ROLES,
    label: "Roles",
  },
  {
    code: "permissionsDataApi",
    route: PERMISSIONS_DATAAPI,
    label: "Permisos Data API",
  },
  {
    code: "permissionsCC",
    route: PERMISSIONS_CONTROLCENTRE,
    label: "Permisos Control Centre",
  },
];

const PrivateLayout = () => {
  const { loading } = useLoading();

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="flex min-h-screen w-full flex-col">
        <header className="sticky top-0 flex h-16 items-center gap-5 border-b bg-background px-4 md:px-6 z-40">
          <DesktopNavigationMenu sections={sections} />
          <MobileNavigationMenu sections={sections} />
          <div className="flex w-full items-center gap-4 md:ml-auto md:gap-2 lg:gap-4">
            <div className="ml-auto flex-1 sm:flex-initial"></div>
            <ProfileDropdownMenu />
          </div>
        </header>
        <main className="flex-1 h-full flex-col bg-muted/40 sm:gap-4 sm:py-4">
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default PrivateLayout;
